import { Button } from "@/components/ui/button";
import { History, X } from "lucide-react";

interface DraftRestoreBannerProps {
  age: string | null;
  onRestore: () => void;
  onDismiss: () => void;
}

export const DraftRestoreBanner = ({ age, onRestore, onDismiss }: DraftRestoreBannerProps) => {
  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
          <History className="h-4 w-4 text-primary" />
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">Restore unsaved draft?</p>
          <p className="text-xs text-muted-foreground">
            We auto-saved your last entries{age ? ` (${age})` : ""}.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button size="sm" variant="ghost" onClick={onDismiss} className="h-8">
          <X className="h-4 w-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
        <Button size="sm" onClick={onRestore} className="h-8">
          Restore
        </Button>
      </div>
    </div>
  );
};
